import React from 'react';
import * as S from './WhyMyPartner.styles';

import PartnerVideo from './PartnerVideo/PartnerVideo';
import PartnerInfo from './PartnerInfo/PartnerInfo';

const WhyMyPartner = ({timeZone}) => {
  return (
    <S.WhyPartnerMainWrap id="whymypartner">
      <S.WhyPartnerInnerWrap>
        <S.WhyPartnerHeadWrap>
          <S.WhyPartnerHeadText timeZone={timeZone}>Why myPartner?</S.WhyPartnerHeadText>
          <S.WhyPartnerSubText>
            Join us to discover the smart way to grow your business
          </S.WhyPartnerSubText>
        </S.WhyPartnerHeadWrap>
        {<PartnerVideo timeZone={timeZone} />}
        <PartnerInfo timeZone={timeZone} />
      </S.WhyPartnerInnerWrap>
    </S.WhyPartnerMainWrap>
  );
};

export default WhyMyPartner;
